module.exports = __webpack_public_path__ + "media/kirby.7f4c234b.wav";